import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateCapitalUnderline
} from '@/util/validate'
import {baseUrl} from '@/config/env';


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门名称为1-30位中文'))
    } else {
        callback();
    }
}

const validateCode = (rule, value, callback) => {
    if (!validateCapitalUnderline(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门编号为1-30位大写字母加下划线组成'))
    } else {
        callback();
    }
}
export const pointsRuleTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '120',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "奖惩类型",
            prop: "type",
            search: true,
            type: 'select',
            dicData: DIC.POINTS_RULE_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择奖惩类型"
            }]
        },{
            label: "对应积分",
            prop: "points",
            placeholder: "请输入对应积分",
            type: 'number',
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入对应积分"
            }]
        },
        {
            label: "描述",
            prop: "pointsDescribe",
            type: "textarea",
            span : 24,
            max: 255
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATUS_STATE_MODEL
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        }


    ]
};